/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360BusinessLogicRetailersOpeningHoursBEInterval } from './open360BusinessLogicRetailersOpeningHoursBEInterval';


export interface Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours {
    /**
     * 0 = Sunday, 1 = Monday, 2 = Tuesday, 3 = Wednesday, 4 = Thursday, 5 = Friday, 6 = Saturday
     */
    DayOfWeek: Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours.DayOfWeekEnum;
    DayOfWeekString?: string;
    Open24Hours?: boolean;
    OpeningHours?: Array<Open360BusinessLogicRetailersOpeningHoursBEInterval>;
}
export namespace Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours {
    export type DayOfWeekEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;
    export const DayOfWeekEnum = {
        NUMBER_0: 0 as DayOfWeekEnum,
        NUMBER_1: 1 as DayOfWeekEnum,
        NUMBER_2: 2 as DayOfWeekEnum,
        NUMBER_3: 3 as DayOfWeekEnum,
        NUMBER_4: 4 as DayOfWeekEnum,
        NUMBER_5: 5 as DayOfWeekEnum,
        NUMBER_6: 6 as DayOfWeekEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours.ts